<template>
  <svg
    viewBox="0 0 1024 1024"
    class="edit-icon"
    :fill="color"
    :class="iconClass"
  >
    <path
      d="M884 300l-78 78-160-160 78-78q12-12 30-12t30 12l100 100q12 12 12 30t-12 30zM128 736l472-472 160 160-472 472h-160v-160z"
    ></path>
  </svg>
</template>
<script>
/**
 * @description Componente que exibe o icone de editar
 */
export default {
  name: "EditIcon",
  props: {
    color: {
      type: String,
      default: "white",
    },
    size: {
      type: String,
      default: "1.5rem",
    },
  },
  computed: {
    iconColor() {
      switch (this.color) {
        case "white":
          return "edit-icon";
        case "black":
          return "edit-icon-black";
        default:
          return "edit-icon";
      }
    },
    iconSize() {
      switch (this.size) {
        case "x-small":
          return "x-small";
        case "small":
          return "small";
        case "medium":
          return "medium";
        case "large":
          return "large";
        default:
          return "medium";
      }
    },
    iconClass() {
      return this.iconColor + " " + this.iconSize;
    },
  },
};
</script>
<style scoped>
.edit-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.edit-icon:hover {
  fill: var(--dl-color-gray-white);
  cursor: pointer;
}

.edit-icon-black {
  width: 1.5rem;
  height: 1.5rem;
}

.edit-icon-black:hover {
  fill: var(--dl-color-gray-700);
  cursor: pointer;
}

.x-small {
  width: 0.75rem;
  height: 0.75rem;
}

.small {
  width: 1rem;
  height: 1rem;
}

.medium {
  width: 1.25rem;
  height: 1.25rem;
}

.large {
  width: 2rem;
  height: 2rem;
}
</style>
